import { Icon, Popup, Table } from "semantic-ui-react";
import { RequestFeedbackIndicator } from "../../components/RequestFeedbackIndicator/RequestFeedbackIndicator";
import {
    AuthorizationType,
    authorizationTypeOptions,
    IAuthorization,
} from "../../models/authorization";
import { certificateStatusOptions } from "../../models/certificate";
import { formatDate, riverRangeProps } from "../../models/common";
import { IssuingAuthorityIndicator } from "../../components/IssuingAuthorityIndicator/IssuingAuthorityIndicator";
import { TranslateProps } from "../../i18n/TranslateProps";

type Props = {
    authorization: IAuthorization;
};

const formatRanges = (authorization: IAuthorization) => {
    if (authorization.type !== AuthorizationType.S) {
        return;
    }

    const stretches = authorization.riverKilometers
        .map(str => `${riverRangeProps.find(r => r.key === str)?.text?.toString() ?? ""}`)
        .sort((a, b) => a.localeCompare(b));

    return (
        <span>
            <Popup
                content={stretches.map(r => (
                    <p key={r}>{r}</p>
                ))}
                position="top center"
                flowing
                trigger={<Icon name="info circle" size="large" />}
                hoverable
            />
        </span>
    );
};

export const AuthorizationsRow = ({ authorization }: Props) => {
    return (
        <Table.Row>
            <Table.Cell>
                <IssuingAuthorityIndicator issuingAuthority={authorization.issuingAuthority} />
            </Table.Cell>
            <Table.Cell>
                {
                    TranslateProps(authorizationTypeOptions).find(
                        t => t.value === authorization.type
                    )?.text
                }
                {formatRanges(authorization)}
            </Table.Cell>
            <Table.Cell>{authorization.qualificationID}</Table.Cell>
            <Table.Cell>{authorization.linkedQualificationID}</Table.Cell>
            <Table.Cell>{formatDate(authorization.endDate)}</Table.Cell>
            <Table.Cell>
                {
                    TranslateProps(certificateStatusOptions).find(
                        x => x.value === authorization.status
                    )?.text
                }
            </Table.Cell>
            <Table.Cell style={{ textAlign: "right" }}>
                {authorization.requestFeedbacks.length > 0 && (
                    <RequestFeedbackIndicator feedbacks={authorization.requestFeedbacks} />
                )}
            </Table.Cell>
        </Table.Row>
    );
};
